import request from '../utils/request'

const prefix = '/api/v1/back'
//机构--创建推广商品
export function createWarrantProduct(query) {
  return request({
    url: `${prefix}/crm/warrant/product`,
    method: 'post',
    data: query

  })
}
//机构--推广商品列表
export const warrantProductlist = (query) => {
  return request({
    url: `${prefix}/crm/warrant/product/list`,
    method: 'get',
    params: query
  })
}
//机构--修改推广商品
export const updateWarrantProduct = (query) => {
  return request({
    url: `${prefix}/crm/warrant/product`,
    method: 'put',
    data: query
  })
}
//加盟--删除商品
export const deleteWarrantProduct = (query) => {
  return request({
    url: `${prefix}/crm/warrant/product/list`,
    method: 'delete',
    data: query
  })
}

//加盟--订单列表
export const warrantOrderlist = (query) => {
  return request({
    url: `${prefix}/crm/warrant/order/list`,
    method: 'get',
    params: query
  })
}

//加盟--订单详情
export const warrantOrderOne = (query) => {
  return request({
    url: `${prefix}/crm/warrant/order`,
    method: 'get',
    params: query
  })
}
//加盟--物流详情
export const warrantOrderExpress = (query) => {
  return request({
    url: `${prefix}/crm/warrant/order/expressInfo`,
    method: 'get',
    params: query
  })
}
//加盟--发货
export function warrantOrderShoping(query) {
  return request({
    url: `${prefix}/crm/warrant/order/shipping`,
    method: 'post',
    data: query

  })
}
//加盟--核销列表
export const taskList = (query) => {
  return request({
    url: `${prefix}/product/startProductCode/task/list`,
    method: 'get',
    params: query
  })
}



